export default "__VITE_ASSET__CZUWGiCI__"